// Consent Types
export const CONSENT_TYPE_MISSED_CALL_HANDLER = 'aloai_missed_call_handler'
export const CONSENT_TYPE_IVA_CONVERSION = 'iva_conversion'

// Consent Decisions
export const CONSENT_DECISION_ACCEPTED = 'accepted'
export const CONSENT_DECISION_DECLINED = 'declined'
